import { createProvider } from "src/common/factories/createProvider.tsx";
import type { SnackbarStore } from "src/App/SnackbarStore.ts";

export const { Provider: SnackbarProvider, useContext: useSnackbar } =
  createProvider<SnackbarStore>(null, "Snackbar");
